const features = [
  {
    icon: 'ri-speed-up-line',
    title: '多平台聚合',
    desc: '汇聚久久视频、芒果视频、97视频、丝瓜视频等8+主流在线视频平台入口，一站式导航，无需反复搜索。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清不缓冲',
    desc: '精选各平台高清视频资源入口，优先推荐流畅稳定的播放线路，保障观影体验不打折。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '内容入口保持每日更新节奏，第一时间同步各平台最新影视资讯与热门内容推荐。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '所有平台入口均经过人工审核验证，确保链接安全有效，为您提供绿色健康的上网环境。',
  },
  {
    icon: 'ri-compass-3-line',
    title: '精准导航',
    desc: '按平台、类型、热度等多维度分类，帮助您快速定位心仪的视频内容，节省查找时间。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-star-line"></i>
            核心优势
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            为什么选择青青草视频
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            五大核心优势，为您提供更便捷的在线视频导航体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all group cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}